import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { EntityAvatar } from "@components/avatar/EntityAvatar";
import { ClientsWorkOverviewRow } from "../clientsWorkOverviewViewConfig";
import styles from "./WorkEntityCell.module.scss";

export const WorkEntityCell = memo(
    ({
        row,
    }: CellContext<
        ViewTableFeatures,
        ClientsWorkOverviewRow,
        number | undefined
    >) => {
        if (row.original.rowType !== "work") {
            return null;
        }

        const { entityName, entityIconColor, entityLogo } = row.original;

        return (
            <div className={styles.container}>
                <EntityAvatar
                    size="xs"
                    entity={{
                        name: entityName,
                        iconColor: entityIconColor,
                        logo: entityLogo,
                    }}
                    aria-hidden
                />
                <span className={styles.name}>{entityName}</span>
            </div>
        );
    },
);

WorkEntityCell.displayName = "WorkEntityCell";
